import "layouts/tailwind.css";
import "shared/utils/rollbar.js"
import "@fortawesome/fontawesome-free/js/all.js"
import "shared/flashes.js"

require("@rails/ujs").start();
